import axios from "axios";
import qs from "qs";

export const messageService = {
	fetchMessages,
	createAdminMsg,
	getMessageByKey,
	updateAdminMsg,
	deleteAdminMsg,
	createBatchAdminMsg,
};

const httpOptions = {
	headers: {
		"Content-Type": "application/json",
	},
	withCredentials: true,
};

async function fetchMessages(form) {
	return axios({
		url: `${process.env.REACT_APP_BACKEND_URL}/adminmsg`,
		...httpOptions,
		method: "GET",
		params: form,
		paramsSerializer: (params) => {
			return qs.stringify(params);
		},
	})
		.then(handleResponse)
		.catch(handleError);
}
async function getMessageByKey(key) {
	return axios({
		url: `${process.env.REACT_APP_BACKEND_URL}/adminmsg/${key}`,
		...httpOptions,
		method: "GET",
	})
		.then(handleResponse)
		.catch(handleError);
}

async function createAdminMsg(data) {
	return axios({
		url: `${process.env.REACT_APP_BACKEND_URL}/adminmsg`,
		...httpOptions,
		data: data,
		method: "POST",
	})
		.then(handleResponse)
		.catch(handleError);
}

async function createBatchAdminMsg(data) {
	return axios({
		url: `${process.env.REACT_APP_BACKEND_URL}/adminmsg/batch`,
		...httpOptions,
		data: data,
		method: "POST",
	})
		.then(handleResponse)
		.catch(handleError);
}

async function updateAdminMsg(data) {
	return axios({
		url: `${process.env.REACT_APP_BACKEND_URL}/adminmsg`,
		...httpOptions,
		data: data,
		method: "PUT",
	})
		.then(handleResponse)
		.catch(handleError);
}

async function deleteAdminMsg(data) {
	return axios({
		url: `${process.env.REACT_APP_BACKEND_URL}/adminmsg`,
		...httpOptions,
		data: data,
		method: "DELETE",
	})
		.then(handleResponse)
		.catch(handleError);
}

function handleError(err) {
	const msg = (err.response && err.response.data.message) || err.message || err;
	throw { error: msg };
}

function handleResponse(res) {
	return res.data;
}
